import { AdminShift } from '../model/adminShift';
import { AdminShiftList } from '../model/adminShift-list';
export class AdminShiftBuilder {
    static buildAdminShift(data) {
        const adminShift = new AdminShift();
        adminShift.id = data.id;
        adminShift.idLot = data.id_lot;
        adminShift.idUser = data.id_user;
        adminShift.name = data.name;
        adminShift.alias = data.alias;
        adminShift.closed = data.closed;
        adminShift.begin = data.begin;
        adminShift.end = data.end;
        adminShift.cashEnd = data.cash_end;
        adminShift.cashBegin = data.cash_begin;
        adminShift.cashSales = data.cash_sales;
        adminShift.cashIn = data.cash_in;
        adminShift.cashOut = data.cash_out;
        adminShift.cardSales = data.card_sales;
        adminShift.is_premium = +data.is_premium ? true : false;
        return adminShift;
    }
    static buildAdminShiftList(data) {
        const adminShiftList = new AdminShiftList();
        adminShiftList.page = data.page;
        adminShiftList.pagination = data.pagination;
        adminShiftList.totalCount = data.total;
        adminShiftList.totalPages = data.totalPages;
        adminShiftList.shifts = _.map(data.shift, (adminShift) => {
            return AdminShiftBuilder.buildAdminShift(adminShift);
        });
        return adminShiftList;
    }
}
//# sourceMappingURL=adminShift-builder.js.map